
import "./About.css";

import React from 'react'

function About() {
  return (
    <section id="about" className="about">
    <h2>About Us</h2>
    <p>
      Jon David is a creative company delivering innovative digital solutions.
      We focus on design, technology, and business impact.
    </p>
  </section>
  )
}

export default About
